import { render, staticRenderFns } from "./ourBenefits.vue?vue&type=template&id=d36df168&scoped=true"
import script from "./ourBenefits.vue?vue&type=script&lang=js"
export * from "./ourBenefits.vue?vue&type=script&lang=js"
import style0 from "./ourBenefits.vue?vue&type=style&index=0&id=d36df168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36df168",
  null
  
)

export default component.exports